<script>

    import { fade } from 'svelte/transition'
    import { toast } from 'bulma-toast'
    import { shipmentStore, shipmentsStore } from '../stores'

    import TrackingsService from '../$services/trackings.service.js'
    import ShipmentsService from '../$services/shipments.service.js'
    import DateMethod from '../$methods/date.method.js'
    
    import Spinner from '../$components/spinner.svelte'
    import Message from '../$components/message.svelte'
    import ButtonDelete from '../$components/button.delete.svelte'

    let loading = false
    let deleting = false
    let trackings = []

    getTracking()

    async function getTracking() {

        loading = true
        const resp = await TrackingsService.getTracking($shipmentStore._id)
        loading = false

        if(!resp.success)
            return toast({message: resp.error.message, type: 'is-danger'})

        trackings = resp.data

        if(resp.trackingStatus)
            $shipmentStore.trackingStatus = resp.trackingStatus

        $shipmentsStore.tracking = resp.data

        shipmentsStore.replace($shipmentStore)
    }

    async function deleteTracking(tracking) {

        deleting = true
        const resp = await ShipmentsService.deleteShipmentTracking($shipmentStore._id, tracking._id)
        deleting = false

        if(!resp.success)
            return toast({message: resp.error.message, type: 'is-danger'})

        trackings = trackings.filter(item => item._id !== tracking._id)

        shipmentStore.set(resp.data)
        shipmentsStore.replace(resp.data)

        toast({message: 'Tracking eliminado', type: 'is-success'})
    }

</script>

<div class="is-flex is-justify-content-flex-start is-align-items-center">
    <div class="subtitle is-5">Tracking</div>
</div>

<Message show={!loading && !trackings.length} />
<Spinner {loading} />

{#if !loading && trackings.length}
    <div class="timeline" in:fade>
        <header class="timeline-header">
            <span class="tag is-medium is-light">Inicio</span>
        </header>
        {#each trackings as tracking}
            <div class="timeline-item is-success">
                <div class="timeline-marker is-info"></div>
                <div class="timeline-content">
                    <p class="heading">{ tracking.name }</p>
                    <div>
                        <div>{ tracking.details || 'Sin detalles' }</div>
                        <small>{ DateMethod.dateTimeLarge(tracking.created) }</small>
                        {#if tracking.location}
                            <div>
                                <a target="_blank" href="https://www.google.com/maps/search/?api=1&query={tracking.location.lat},{tracking.location.lng}">Ver ubicación</a>
                            </div>
                        {/if}
                        {#if tracking.driver}
                            <div>{ tracking.driver.email }</div>
                            <div>{ tracking.driver.name }</div>
                        {/if}
                        {#if $shipmentStore.provider === 'TIL' && tracking._id}
                            <div class="mt-2">
                                <ButtonDelete on:confirm={() => deleteTracking(tracking)} loading={deleting} size="small" text="Eliminar" />
                            </div>
                        {/if}
                    </div>
                </div>
            </div>
        {/each}
        <div class="timeline-header">
            <span class="tag is-medium is-light">Final</span>
        </div>
    </div>
{/if}